import api from 'api/api'
import { toast } from "react-toastify"

import { API_URL } from 'constants/index'

export const GET_USER_ASSIGNABLE_MENUS = "[ACCESS_CONTROL] GET USER_ASSIGNABLE_MENUS"

export const CRUD_USER_MENUS = "[ACCESS_CONTROL] CRUD USER MENUS"

export function getUserAssignableMenus(userId = 0) {
  const request = api.get(`/usuario-menu/menus-a-seleccionar/${userId}`)
  return (dispatch) => {
    dispatch({ type: GET_USER_ASSIGNABLE_MENUS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_USER_ASSIGNABLE_MENUS, payload: { loading: false, data: response.data.detalles } })
    }).catch((error) => {
      dispatch({ type: GET_USER_ASSIGNABLE_MENUS, payload: { loading: false, data: null } })
      toast.error("Error al obtener los menús asignables")
      console.log(error)
    })
  }
}

export function saveUserMenus(form) {
  const request = api.post(`/usuario-menu/guardar-menus`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_USER_MENUS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: CRUD_USER_MENUS, payload: { loading: false, crud: true } })
      toast.success(response.data.message)

      setTimeout(() => {
        dispatch({ type: CRUD_USER_MENUS, payload: { loading: false, crud: false } })
      }, 50)

    }).catch((error) => {
      dispatch({ type: CRUD_USER_MENUS, payload: { loading: false, crud: false } })
      toast.error("Ocurrió un error inesperado. Intente nuevamente.")
      console.log(error)
    })
  }
}
